import { GetPickupGuideOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, silentQueryErrorHandler } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

type Input = { tripKey: string };

export const fetchTripGuideDownload = async ({ tripKey }: Input) =>
  await passengerApi.get<Input, GetPickupGuideOutput>(`/transport/v1/trip/${tripKey}/pickup-guide`);

export const useFetchTripGuideDownload = (tripKey: string) =>
  useQuery(queryKeys.fetchTripGuideDownload(tripKey), () => fetchTripGuideDownload({ tripKey }), {
    staleTime: DEFAULT_CACHE_TIME,
    onError: silentQueryErrorHandler,
  });
